import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@pearsontechnology/aero-components';
import Modal, { ModalContent } from 'components/Modal';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { MAX_FAVORITES_LIMIT as limit } from 'constants/favoritesLimit';
import messages from './messages';
import { ModalBodyHeader, ModalBodyText, ModalButtonActions } from './styles';

function FavoritesLimitModal({ visible, onDismiss }) {
  return (
    <Modal
      onDismiss={onDismiss}
      visible={visible}
    >
      <ModalContent>
        <ModalBodyHeader>
          {intl.formatMessage(messages.modalBodyHeader)}
        </ModalBodyHeader>
        <ModalBodyText>
          {intl.formatMessage(messages.modalBodyDescription, { limit })}
        </ModalBodyText>
      </ModalContent>
      <ModalButtonActions>
        <Button primary onClick={onDismiss}>
          {intl.formatMessage(messages.okButton)}
        </Button>
      </ModalButtonActions>
    </Modal>
  );
}

FavoritesLimitModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func,
};

export default FavoritesLimitModal;
